import React from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/ux-common/components/accordion/accordion';
import { Header, HeaderTitle } from '@/ux-common/components/header/header';
import { Stack } from '@/ux-common/components/stack/stack';
import { Typography } from '@/ux-common/components/typography/typography';

interface SequencerInstructionsProps {
  /** The instruction content specific to the sequencer type */
  children: React.ReactNode;
  /** Unique identifier for the accordion (used for accessibility and keys) */
  id: string;
}

/**
 * SequencerInstructions provides a collapsible accordion for sequencer-specific instructions.
 * The content is passed as children, allowing each sequencer type to define its own instructions.
 *
 * @example
 * <SequencerInstructions id="condenser">
 *   <Typography variant="body">
 *     Instructions for condenser sequencer...
 *   </Typography>
 * </SequencerInstructions>
 */
export const SequencerInstructions: React.FC<SequencerInstructionsProps> = ({ children, id }) => {
  return (
    <Accordion
      key={`accordion-${id}-sequencer-editor-instructions`}
      type="multiple"
      defaultValue={[]}
    >
      <AccordionItem value={`${id}-sequencer-editor-instructions`}>
        <AccordionTrigger>
          <Header>
            <HeaderTitle>
              <Typography as="h3" className="text-nav-header">
                Instructions
              </Typography>
            </HeaderTitle>
          </Header>
        </AccordionTrigger>
        <AccordionContent className="pt-thin p-2 select-text">
          <Stack className="select-text">{children}</Stack>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
